import { combineEpics } from "redux-observable";
import { epicTutorialConstructConfirm } from "./epics/epicTutorialConstructConfirm";
import { epicTutorialConstructConfirmPlacement } from "./epics/epicTutorialConstructConfirmPlacement";
import { epicTutorialConstructConstructionProgress } from "./epics/epicTutorialConstructConstructionProgress";
import { epicTutorialHarvest } from "./epics/epicTutorialHarvest";
import { epicTutorialInit } from "./epics/epicTutorialInit";
import { epicTutorialOnBuildingSelect } from "./epics/epicTutorialOnBuildingSelect";
import { epicTutorialOnCloseLevelUpScreen } from "./epics/epicTutorialOnCloseLevelUpScreen";
import { epicTutorialOnModalOpen } from "./epics/epicTutorialOnModalOpen";
import { epicTutorialOnProductionStart } from "./epics/epicTutorialOnProductionStart";
import { epicTutorialOnRecipeSelect } from "./epics/epicTutorialOnRecipeSelect";
import { epicTutorialQuestClickQuestMenu } from "./epics/epicTutorialQuestClickQuestMenu";
import { epicTutorialQuestCompleteClick } from "./epics/epicTutorialQuestCompleteClick";
import { epicTutorialSelect } from "./epics/epicTutorialSelect";
import { epicTutorialStart } from "./epics/epicTutorialStart";
export var epicTutorial = combineEpics(epicTutorialStart, epicTutorialSelect, epicTutorialHarvest, epicTutorialConstructConfirmPlacement, epicTutorialConstructConstructionProgress, epicTutorialConstructConfirm, epicTutorialQuestClickQuestMenu, epicTutorialOnProductionStart, epicTutorialOnRecipeSelect, epicTutorialOnModalOpen, epicTutorialOnBuildingSelect, epicTutorialQuestCompleteClick, epicTutorialInit, epicTutorialOnCloseLevelUpScreen);



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epicTutorial.ts
// module id = 2459
// module chunks = 3